<app-global-header
  [theme]="headerTheme"
  [goBackRoute]="goBackRoute$ | async"
  [header]="'TRANSACTION_HISTORY.PAYMENT_HISTORY' | translate"
>
  <right-slot>
    <button
      i2gButton
      buttonStyle="emphasis"
      class="add-payment-action"
      trackable
      data-e2e-id="add-payment-action"
      [trackingObject]="documentTrackingObject$ | async"
      [trackingAction]="addPaymentTrackingAction"
      [disabled]="!(isAllAccess$ | async)"
      (click)="openManualPaymentDialog()"
    >
      {{ 'ACTION.ADD_PAYMENT' | translate }}
    </button>
  </right-slot>
</app-global-header>

<div class="transaction-history-content">
  <header class="transaction-history-header">
    <ng-container
      *ngIf="documentInfo$ | async as documentInfo; else placeholder"
    >
      <div class="document-info">
        <span>
          {{ documentInfo }}
        </span>

        <span *ngIf="clientName$ | async as clientName" class="client-info">
          {{ clientName }}
        </span>
      </div>

      <div
        *ngIf="documentBalance$ | async as documentBalance"
        [innerHTML]="documentBalance | safe: 'html'"
        class="balance"
      ></div>
    </ng-container>

    <ng-template #placeholder>
      <div class="placeholder-contents">
        <div class="placeholder placeholder-info shimmer"></div>
        <div class="placeholder placeholder-balance shimmer"></div>
      </div>
    </ng-template>
  </header>

  <app-transaction-history-list
    class="transaction-history-list"
    [documentPaymentTransactions]="documentPaymentTransactions$ | async"
    [headers]="headers"
    [documentLocale]="documentLocale$ | async"
    [isAllAccess]="isAllAccess$ | async"
    [trackingScreenName]="trackingScreenName"
    [documentTrackingObject]="documentTrackingObject$ | async"
    (onAction)="onAction($event)"
  >
  </app-transaction-history-list>
</div>

<app-manual-payment-dialog
  [trackingScreenName]="trackingScreenName"
  [invalidEmailDialogId]="invalidEmailDialogId"
  [currencyCode]="documentCurrencyCode$ | async"
  [locale]="documentLocale$ | async"
  [calculationResult]="documentCalculationResult$ | async"
  [paymentUrl]="documentPaymentUrl$ | async"
  [document]="document$ | async"
  [companySettings]="companySettings"
  [documentBilling]="documentBilling$ | async"
  [isKicEnablingPayment]="isKicEnablingPayment$ | async"
  (onAddManualPayment)="createManualPayment($event)"
  (onSendPreviewReceipt)="sendPreviewReceipt($event)"
  (onKICPaymentSuccess)="refreshTransactions()"
  (onEnableCardPayments)="onEnableCardPayments()"
>
</app-manual-payment-dialog>

<app-send-receipt-dialog
  [trackingScreenName]="trackingScreenName"
  (onSendReceipt)="sendReceipt($event)"
  (onPreviewReceipt)="sendPreviewReceipt($event)"
>
</app-send-receipt-dialog>

<app-confirm-dialog
  [dialogId]="invalidEmailDialogId"
  [confirmTitle]="'LABEL.CLIENT_EMAIL_REQUIRED' | translate"
  [confirmPrompt]="'DIALOG.RECEIPTS.INVALID_EMAIL_INFO' | translate"
  [cancelText]="'ACTION.CANCEL' | translate"
  [yesText]="'ACTION.ADD_CLIENT_EMAIL' | translate"
  [isDeleteAction]="true"
  (onClose)="onInvalidClientEmail($event)"
>
</app-confirm-dialog>

<app-onboarding-stripe-dialog
  [underwritingUrl]="underwritingUrl$ | async"
  [trackingScreenName]="trackingScreenName"
>
</app-onboarding-stripe-dialog>
